import React, { useState, useEffect, useContext } from 'react';
import '../App.css';
import { GrupoContext } from '../GrupoContext';
import axios from 'axios';
import Sidebar from '../componenteExtra/SidebarLider';
import { useNavigate } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import SessionManager from '../componenteExtra/SessionManager';
import * as XLSX from 'xlsx';

const AsignarStaff = () => {
    const navigate = useNavigate();
    const { grupo, setGrupo } = useContext(GrupoContext);
    const [activities, setActivities] = useState([]);
    const [filteredActivities, setFilteredActivities] = useState([]);
    const [staffList, setStaffList] = useState([]);
    const [selectedRows, setSelectedRows] = useState({});
    const [searchTerm] = useState("");

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        const savedGrupo = localStorage.getItem('grupo');
        if (savedGrupo) {
            setGrupo(savedGrupo);
        }

        if (grupo) {
            fetchActivitiesAndStaff();
        }
    }, [grupo]);

    const fetchActivitiesAndStaff = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/asignar_staff/${grupo}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(response => {
                const normalized = response.data.map(act => ({
                    ...act,
                    fecha_de_inicio: act.fecha_de_inicio || "",
                    fecha_de_termino: act.fecha_de_termino || "",
                    staff_asignado: act.staff_asignado || ""
                }));
                setActivities(normalized);
                setFilteredActivities(normalized);
            })
            .catch(error => console.error('Error fetching activities: ', error));

        axios.get(`${process.env.REACT_APP_BACKEND_URL}/buscar_staff/${grupo}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(response => {
                setStaffList(response.data);
            })
            .catch(error => console.error('Error fetching staff: ', error));
    };

    useEffect(() => {
        if (grupo) {
            localStorage.setItem('grupo', grupo);
        }
    }, [grupo]);

    useEffect(() => {
        const newFiltered = activities.filter(activity =>
            activity.codigo_proyecto.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredActivities(newFiltered);
    }, [searchTerm, activities]);

    // TU FUNCIÓN ORIGINAL SIN CAMBIOS
    const calculateEndDate = (startDate, duration) => {
        let endDate = new Date(startDate);
        let daysAdded = 0;
        while (daysAdded < duration) {
            endDate.setDate(endDate.getDate() + 1);
            const dayOfWeek = endDate.getUTCDay();
            if (dayOfWeek !== 0 && dayOfWeek !== 6) {
                daysAdded++;
            }
        }
        return endDate.toISOString().split('T')[0];
    };

    // TU LÓGICA DE FECHA 100% INTACTA + PROPAGACIÓN MASIVA
    const handleFechaInicioChange = (index, value) => {
        if (!value) return;

        const selectedActivity = activities[index];
        const fechaDocumentacion = new Date(selectedActivity.fecha_documentación_actividad);
        const selectedDate = new Date(value);
        const dayOfWeek = selectedDate.getUTCDay();

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const twoDaysAgo = new Date(today);
        twoDaysAgo.setDate(today.getDate() - 1);

        // TUS VALIDACIONES EXACTAS (sin tocar nada)
        if (selectedDate < twoDaysAgo) {
            toast.error('La fecha de inicio no puede ser antes de la fecha actual.');
            return;
        }

        if (selectedDate < fechaDocumentacion) {
            toast.error('La fecha de inicio no puede ser antes de la fecha de documentación.');
            return;
        }

        if (dayOfWeek === 0 || dayOfWeek === 6) {
            toast.error('No se puede seleccionar una fecha en fin de semana.');
            return;
        }

        const endDate = calculateEndDate(value, 5);

        // AQUÍ ESTÁ LA MAGIA: se aplica a todas las marcadas sin fecha
        setActivities(prev => prev.map((activity, i) => {
            const isSelected = selectedRows[i];
            const hasNoStartDate = !activity.fecha_de_inicio || activity.fecha_de_inicio === "";

            if (isSelected && hasNoStartDate) {
                return {
                    ...activity,
                    fecha_de_inicio: value,
                    fecha_de_termino: endDate
                };
            }
            if (i === index) {
                return {
                    ...activity,
                    fecha_de_inicio: value,
                    fecha_de_termino: endDate
                };
            }
            return activity;
        }));

        // Resaltar todos los inputs con fecha
        setTimeout(() => {
            document.querySelectorAll('input[type="date"]').forEach(input => {
                input.classList.toggle('highlight', input.value !== '');
            });
        }, 0);
    };

    // STAFF: misma lógica masiva
    const handleStaffChange = (index, value) => {
        if (!value) return;

        setActivities(prev => prev.map((activity, i) => {
            const isSelected = selectedRows[i];
            const hasNoStaff = !activity.staff_asignado || activity.staff_asignado === "";

            if (isSelected && hasNoStaff) {
                return { ...activity, staff_asignado: value };
            }
            if (i === index) {
                return { ...activity, staff_asignado: value };
            }
            return activity;
        }));

        setTimeout(() => {
            document.querySelectorAll('select').forEach(select => {
                select.classList.toggle('highlight', select.value !== '');
            });
        }, 0);
    };

    const toggleRow = (index) => {
        setSelectedRows(prev => ({ ...prev, [index]: !prev[index] }));
    };

    const handleContinue = () => {
        const selectedIndices = Object.keys(selectedRows)
            .filter(key => selectedRows[key])
            .map(Number);
        const selectedActivities = selectedIndices
            .map(i => activities[i])
            .filter(Boolean);

        if (selectedActivities.length === 0) {
            toast.error('Por favor seleccione al menos una actividad.');
            return;
        }

        const allStaffSelected = selectedActivities.every(a => a.staff_asignado?.trim());
        const allDatesSelected = selectedActivities.every(a => a.fecha_de_inicio?.trim());

        if (!allStaffSelected) {
            toast.error('Por favor seleccione un staff para todas las actividades seleccionadas.');
            return;
        }

        if (!allDatesSelected) {
            toast.error('Por favor ingrese una fecha de inicio para todas las actividades seleccionadas.');
            return;
        }

        const updatedActivities = selectedActivities.map(a => ({
            ...a,
            estado_asignaciones: a.estado_asignaciones + 1
        }));

        const toastId = toast.loading('Actualizando asignaciones...');

        axios.put(`${process.env.REACT_APP_BACKEND_URL}/update_staff_assignment`, updatedActivities, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then(() => {
                toast.dismiss(toastId);
                toast.success('Asignaciones actualizadas correctamente');
                setTimeout(() => {
                    navigate('/menulider');
                    fetchActivitiesAndStaff();
                }, 1500);
            })
            .catch(error => {
                toast.dismiss(toastId);
                toast.error('Error al actualizar: ' + (error.response?.data?.message || error.message));
            });

        // Actualizar contadores de staff
        const updatedStaffList = staffList.map(staff => {
            const assignedCount = selectedActivities.filter(a => a.staff_asignado === staff.nombre_asistente).length;
            return {
                ...staff,
                cantidad_actividad_asignadas: staff.cantidad_actividad_asignadas + assignedCount,
                sumatoria_actividades_asignadas: (staff.sumatoria_actividades_asignadas || 0) + assignedCount
            };
        });

        axios.put(`${process.env.REACT_APP_BACKEND_URL}/update_asistente`, updatedStaffList, {
            headers: { Authorization: `Bearer ${token}` },
        }).catch(error => console.error('Error updating staff:', error));
    };

    const handleDownloadExcel = () => {
        const data = filteredActivities.map(a => ({
            'Código de Proyecto': a.codigo_proyecto,
            'Razón Social': a.razon_social,
            'Filial': a.filial,
            'Tipo de trabajo': a.tipo_solicitud,
            'Regulación': a.tipo_regulacion,
            'Socio de auditoría': a.encargado_auditoria,
            'Rubro GET': a.rubro_get,
            'Nombre Actividad GET': a.nombre_actividad_get,
            'Enlace Comentario': a.enlace_comentario,
            'Fecha Entrega Información': a.fecha_entrega_informacion ? new Date(a.fecha_entrega_informacion).toLocaleDateString('es-ES') : '',
            'Fecha Documentación': a.fecha_documentación_actividad ? new Date(a.fecha_documentación_actividad).toLocaleDateString('es-ES') : '',
            'Fecha Término Senior': a.fecha_termino_senior_actividad ? new Date(a.fecha_termino_senior_actividad).toLocaleDateString('es-ES') : '',
            'Fecha Corte Auditoría': a.fecha_corte_auditoria ? new Date(a.fecha_corte_auditoria).toLocaleDateString('es-ES') : '',
            'Staff Asignado': a.staff_asignado || '',
            'Fecha Inicio Staff': a.fecha_de_inicio || '',
            'Fecha Término Staff': a.fecha_de_termino || ''
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Asignaciones');
        XLSX.writeFile(wb, `AsignarStaff_Grupo_${grupo}.xlsx`);
    };

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel" style={{ position: 'relative' }}>
                    <div className="total-activities">
                        <h1>Asignar staff - grupo {grupo}</h1>
                        <h2>Total Actividades: {filteredActivities.length}</h2>
                        <p>G: Numero Grupo | Actividades asignadas: ACT | Actividades iniciadas: INI | Horas trabajadas: HRS | Porcentaje de Efectividad: EF | Sumatoria Actividades: SA</p>
                    </div>

                    <button
                        onClick={handleDownloadExcel}
                        disabled={filteredActivities.length === 0}
                        style={{
                            position: 'absolute',
                            top: '50px',
                            right: '15px',
                            backgroundColor: filteredActivities.length === 0 ? '#6c757d' : '#28a745',
                            color: 'white',
                            border: 'none',
                            padding: '20px 16px',
                            borderRadius: '6px',
                            cursor: filteredActivities.length === 0 ? 'not-allowed' : 'pointer',
                            fontSize: '0.95rem',
                            fontWeight: '500',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
                            zIndex: 10,
                        }}
                        onMouseDown={(e) => { if (filteredActivities.length === 0) return; e.currentTarget.style.transform = 'scale(0.96)'; }}
                        onMouseUp={(e) => { if (filteredActivities.length === 0) return; e.currentTarget.style.transform = 'scale(1)'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; }}
                    >
                        <svg width="15" height="15" viewBox="0 0 384 512" fill="white" xmlns="http://www.w3.org/2000/svg">
                            <path d="M48 448V64c0-35.3 28.7-64 64-64H224v96c0 35.3 28.7 64 64 64h96v288c0 35.3-28.7 64-64 64H112c-35.3 0-64-28.7-64-64zm96-80l64 64 64-64H304l-80 80 80 80H208l-64-64-64 64H48l80-80-80-80H144z"/>
                        </svg>
                        Reporte
                    </button>

                    <div className="activities-table-container">
                        <table className="activities-table">
                            <thead>
                                <tr>
                                    <th>
                                    <input
                                        type="checkbox"
                                        checked={Object.values(selectedRows).every(Boolean) && Object.keys(selectedRows).length === filteredActivities.length}
                                        indeterminate={
                                        Object.values(selectedRows).some(Boolean) &&
                                        !Object.values(selectedRows).every(Boolean)
                                        }
                                        onChange={(e) => {
                                        const checked = e.target.checked;
                                        const newSelected = {};
                                        filteredActivities.forEach((_, index) => {
                                            newSelected[index] = checked;
                                        });
                                        setSelectedRows(newSelected);
                                        }}
                                        title="Seleccionar todas"
                                    />
                                    </th>
                                    <th>Código de Proyecto</th>
                                    <th>Razón Social</th>
                                    <th>Filial</th>
                                    <th>Tipo de trabajo</th>
                                    <th>Regulación</th>
                                    <th>Socio de auditoría</th>
                                    <th>Nombre solicitante</th>
                                    <th>Rubro GET</th>
                                    <th>Nombre Actividad GET</th>
                                    <th>Enlace Comentario</th>
                                    <th>Fecha de Entrega de Información</th>
                                    <th>Fecha de Documentación</th>
                                    <th>Fecha de Termino de la Actividad</th>
                                    <th>Fecha Corte Auditoria</th>
                                    <th>Staff Asignado</th>
                                    <th>Fecha Inicio - Staff</th>
                                    <th>Fecha Termino - Staff</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredActivities.map((activity, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedRows[index] || false}
                                                onChange={() => toggleRow(index)}
                                            />
                                        </td>
                                        <td>{activity.codigo_proyecto}</td>
                                        <td>{activity.razon_social}</td>
                                        <td>{activity.filial}</td>
                                        <td>{activity.tipo_solicitud}</td>
                                        <td>{activity.tipo_regulacion}</td>
                                        <td>{activity.encargado_auditoria}</td>
                                        <td>{activity.nombre_solicitante}</td>
                                        <td>{activity.rubro_get}</td>
                                        <td>{activity.nombre_actividad_get}</td>
                                        <td>
                                            {activity.enlace_comentario ? (
                                                <a href={activity.enlace_comentario} target="_blank" rel="noopener noreferrer" style={{ color: "#0066cc", textDecoration: "underline" }}>
                                                    Ver Documentación
                                                </a>
                                            ) : "-"}
                                        </td>
                                        <td>{activity.fecha_entrega_informacion ? new Date(activity.fecha_entrega_informacion).toLocaleDateString("es-ES") : ''}</td>
                                        <td>{activity.fecha_documentación_actividad ? new Date(activity.fecha_documentación_actividad).toLocaleDateString("es-ES") : ''}</td>
                                        <td>{activity.fecha_termino_senior_actividad ? new Date(activity.fecha_termino_senior_actividad).toLocaleDateString("es-ES") : ''}</td>
                                        <td>{activity.fecha_corte_auditoria ? new Date(activity.fecha_corte_auditoria).toLocaleDateString("es-ES") : ''}</td>
                                        <td>
                                            <select
                                                value={activity.staff_asignado || ''}
                                                onChange={(e) => handleStaffChange(index, e.target.value)}
                                                disabled={!selectedRows[index]}
                                                className={activity.staff_asignado ? 'highlight' : ''}
                                            >
                                                <option value="">Seleccione staff</option>
                                                {staffList.map(staff => (
                                                    <option key={staff.nombre_asistente} value={staff.nombre_asistente}>
                                                        {`${staff.nombre_asistente} - G${staff.numero_grupo} ( ACT: ${staff.cantidad_actividad_asignadas}, INI: ${staff.actividades_iniciadas}, HRS: ${staff.horas_get}, EF: ${staff.effectiveness}%, SA: ${staff.sumatoria_actividades_asignadas})`}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                type="date"
                                                value={activity.fecha_de_inicio || ''}
                                                onChange={(e) => handleFechaInicioChange(index, e.target.value)}
                                                disabled={!selectedRows[index]}
                                                className={activity.fecha_de_inicio ? 'highlight' : ''}
                                            />
                                        </td>
                                        <td>{activity.fecha_de_termino || ''}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <button className="continue-button" onClick={handleContinue}>
                        Guardar asignacion(es)
                    </button>
                </div>
            </div>
            <Toaster />
        </div>
    );
};

export default AsignarStaff;